(ns common.schema.entities.workspace.kyc.templates.demo.board-member
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]))

(def schema
  {:kyc-template/template-name
   "Board members"
   :kyc-template/kyc-form-preface
   {:translations {:en "Board members"
                   :fi "Hallituksen jäsenet"}}

   :kyc-board-member.group/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-board-member/first-name]
                    [:kyc-board-member/last-name]
                    [:kyc-board-member/role]
                    [:kyc-board-member/dob]
                    [:kyc-board-member/country]])}
  })
